export const TAG_LOCATOR_REGEX = '(<[^>]+>)*( )*'
export const TAGS_ONLY_REGEX = /(<[^>]+>){1}/g
export const OPENING_TAGS_REGEX = /<[^/]+?[^>]*>/
export const CLOSING_TAGS_REGEX = /<\/[^>]+>/
export const SPECIAL_CHARACTERS_ESCAPE_REGEX = /[?.[\]$*^()|:{}+]{1}/g
export const TRIGGER_CONTAINER_ID = 'ReadMoreExpanderLink'
